module.exports = require("./gsw-FR.js");